import React from "react";
import PropTypes from "prop-types";
import styled from "@emotion/styled";
import { motion } from "framer-motion";

// style rules
import { Animation, Colors, Typography } from "../../styles";

const MediaItemCard = ({ mediaItem }) => {
	return (
		<Card
			initial={"initial"}
			animate={"animate"}
			exit={"initial"}
			variants={Animation.cards.opacityVariants}
		>
			<a href={mediaItem.url}>
				<Title dangerouslySetInnerHTML={{ __html: mediaItem.title }} />
			</a>
			{mediaItem.date && <Date>{mediaItem.date}</Date>}
			{mediaItem.contact && (
				<Contact dangerouslySetInnerHTML={{ __html: mediaItem.contact }} />
			)}
			{mediaItem.excerpt && (
				<Excerpt dangerouslySetInnerHTML={{ __html: mediaItem.excerpt }} />
			)}
			<ReadMore>Read more</ReadMore>
		</Card>
	);
};

export default MediaItemCard;

MediaItemCard.propTypes = {
	mediaItem: PropTypes.object,
};

const ReadMore = styled.div`
	padding-top: 3rem;
	display: flex;

	span {
		color: ${Colors.base.black};
		font-size: 1.4rem;
		line-height: 1.7rem;
	}
`;

const Card = styled(motion.li)`
	list-style: none;
	border-top: 1px #d9d9d9 solid;
	padding-top: 4rem;
	margin: 0;
	position: relative;
	cursor: pointer;

	&:hover {
		background-color: ${Colors.base.lightGray};

		${ReadMore} {
			span {
				&::after {
					width: 100%;
					transition: all 0.2s ease-in-out;
				}
			}
		}
	}

	> a {
		position: unset;
		&::after {
			display: none;
		}

		&::before {
			content: "";
			position: absolute;
			bottom: 0;
			left: 0;
			top: 0;
			right: 0;
			z-index: 1;
		}
	}
`;

const Date = styled.span`
	display: block;
	padding-top: 1rem;
	font-weight: ${Typography.fontWeight.regular};
	font-size: 1.6rem;
	line-height: 2.8rem;
`;

const Title = styled.h3`
	font-size: 1.6rem;
	line-height: 2.1rem;
	text-transform: uppercase;
`;

const Contact = styled.p`
	font-weight: ${Typography.fontWeight.demiBold};
`;

const Excerpt = styled.p`
	padding-top: 2.6rem;
`;
